import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  fetchAllOrdersForDriverUser,
  fetchAllTransactionsForAdminUser,
} from "../../store/order-actions";
import moment from "moment";
import styles from "./DeliveryHistoryPage.module.scss";
import ColumnComponent from "../../components/OrderProcessingComponents/ColumnComponent/ColumnComponent";
import OrderDriverBox from "../../components/OrderProcessingComponents/OrderDriverBox/OrderDriverBox";
import PerfectScrollbar from "react-perfect-scrollbar";
import DateFilterModal from "./DateFilterModal";
import filterIll from "../../assets/icons/filter-ilustration.svg";

const toExclusiveEnd = (inclusiveEnd: string) =>
  moment(inclusiveEnd)
    .add(1, "day")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");

const DeliveryHistoryPage = () => {
  const dispatch = useDispatch();
  const orderState = useSelector((state: RootState) => state.order);
  const [orders, setOrders] = useState<any>(<div>Učitavanje...</div>);

  const [dateFrom, setDateFrom] = useState<string>(
    moment().subtract(7, "days").startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
  );
  const [dateTo, setDateTo] = useState<string>(
    moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
  );
  const [showCalendar, setShowCalendar] = useState<boolean>(false);

  const deliveredOnly = useMemo(
    () =>
      orderState.finishedOrders.filter(
        (o: any) => o.userAddressResponse && o.status === "TAKEN",
      ),
    [orderState.finishedOrders],
  );

  const filteredDeliveredOrders = deliveredOnly;

  const handleApplyDateFilter = (from: string, to: string) => {
    setDateFrom(from);
    setDateTo(to);
    setShowCalendar(false);
    const isAdmin = (localStorage.getItem("roles")?.split(",") || []).includes(
      "ADMIN",
    );
    if (isAdmin) {
      dispatch<any>(fetchAllTransactionsForAdminUser(from, toExclusiveEnd(to)));
    }
  };

  const isAdmin = (localStorage.getItem("roles")?.split(",") || []).includes(
    "ADMIN",
  );
  const loading = isAdmin
    ? orderState.loadingTransactions
    : orderState.loadingOrders;
  const failed = isAdmin
    ? orderState.transactionsFailed
    : orderState.ordersFailed;
  const [hasFetched, setHasFetched] = useState(false);

  // Fetch orders on mount
  useEffect(() => {
    const roles = localStorage.getItem("roles")?.split(",") || [];
    if (roles.includes("ADMIN")) {
      dispatch<any>(
        fetchAllTransactionsForAdminUser(dateFrom, toExclusiveEnd(dateTo)),
      );
    } else {
      dispatch<any>(fetchAllOrdersForDriverUser());
    }
    setHasFetched(true);
  }, [dispatch]);

  useEffect(() => {
    if (!hasFetched) return;
    if (!loading) {
      if (failed) {
        setOrders(
          <div style={{ padding: "20px", textAlign: "center" }}>
            Greška pri učitavanju
          </div>,
        );
      } else {
        if (filteredDeliveredOrders.length === 0) {
          setOrders(
            <div
              style={{ padding: "20px", textAlign: "center", color: "#666" }}
            >
              Nema realizovanih rezervacija
            </div>,
          );
        } else {
          let sortedOrders = [...filteredDeliveredOrders];
          sortedOrders.sort((a: any, b: any) => b.id - a.id);
          setOrders(
            sortedOrders.map((order: any) => (
              <OrderDriverBox
                archived={true}
                key={order.id}
                order={order}
                isAdmin={isAdmin}
              />
            )),
          );
        }
      }
    }
  }, [filteredDeliveredOrders, loading, failed]);

  return (
    <div className={styles.DeliveryHistoryPage}>
      <ColumnComponent
        leftSideLabel={isAdmin ? "Statistika" : "Realizovane rezervacije"}
        leftSideNumber={filteredDeliveredOrders.length.toString()}
        rightSide={
          isAdmin ? (
            <div className={styles.periodControls}>
              <div className={styles.periodInfo}>
                {moment(dateFrom).format("DD.MM.YYYY")} -{" "}
                {moment(dateTo).format("DD.MM.YYYY")}
              </div>
              <div
                className={styles.filtersIcon}
                onClick={() => setShowCalendar(true)}
              >
                <img src={filterIll} alt="Filter" />
              </div>
            </div>
          ) : undefined
        }
        style={{ flex: "4" }}
      >
        <PerfectScrollbar style={{ padding: "4px" }}>{orders}</PerfectScrollbar>
      </ColumnComponent>
      {showCalendar && (
        <DateFilterModal
          initialDateFrom={dateFrom}
          initialDateTo={dateTo}
          onApply={handleApplyDateFilter}
          onCancel={() => setShowCalendar(false)}
        />
      )}
    </div>
  );
};

export default DeliveryHistoryPage;
